:host {
  display: block;
  width: fit-content;
  height: fit-content;
}

afs-image {
  display: block;
  width: 100%;
  height: 100%;
}
